import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconMitula from '../build/icon-mitula'

export const IconMitula: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconMitula} />
}

export default IconMitula
